var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2261 2.25C6.84607 2.25 2.47607 6.62 2.47607 12C2.47607 17.38 6.84607 21.75 12.2261 21.75C17.6061 21.75 21.9761 17.38 21.9761 12C21.9761 6.62 17.6061 2.25 12.2261 2.25ZM12.2261 20.25C7.67607 20.25 3.97607 16.55 3.97607 12C3.97607 7.45 7.67607 3.75 12.2261 3.75C16.7761 3.75 20.4761 7.45 20.4761 12C20.4761 16.55 16.7761 20.25 12.2261 20.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2261 11.25H12.9761V7C12.9761 6.59 12.6361 6.25 12.2261 6.25C11.8161 6.25 11.4761 6.59 11.4761 7V12C11.4761 12.41 11.8161 12.75 12.2261 12.75H17.2261C17.6361 12.75 17.9761 12.41 17.9761 12C17.9761 11.59 17.6361 11.25 17.2261 11.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.52bcb7f5e5d4162b1ee64c00faba896f.svg";
export { ForwardRef as ReactComponent };